define([
    'basemodel',
    'store'
], (BaseModel) => BaseModel.extend({
    urlRoot: '/accounts',

    defaults: {
        id: null,
        parent_id: null,

        // select russian ruble by default
        currency_id: 1,
        name: '',
        type: 'USUAL',
        status: 'ACTIVE',
        created_at: null,
        customer_id: null,
        manager_id: null,
        components: []
    },

    isUser () {
        return this.get('type') === 'USUAL';
    },
    isMCC () {
        return this.get('type') === 'MCC';
    },
    isArchived () {
        return this.get('fact_status') === 'ARCHIVED';
    }
}));
